import axiosClient from "./axiosClient";

export const getSystemStatus = async () => {
    try {
        const response = await axiosClient.get('/system/status');
        return response.data.data;
    } catch (error) {
        throw error;
    }
};


export const setupAccount = async ({ store_name, store_category, channel_name }) => {
    try {
        const response = await axiosClient.post('/setup', { store_name, store_category, channel_name });
        return response.data.data;
    } catch (error) {
        throw error;
    }
};
